import BaseInteriorScene from "../BaseInteriorScene";
import decksmithSource from "./voidDeckSmith-source.json";
import { getVoidCityNpcDialogue } from "../../../@shared/utils/npcDialogs";
import voidDecksmithBg from "../GameMap/InfiNFT Maps/voidDeckSmith.png";
import decksmithNpcPng from "../../../@shared/assets/GameMaps/tilesets/interior/decksmith.png";

const DECKSMITH_NPC_KEY = "decksmithNpcPortrait";
const DECKSMITH_NPC_SCALE = 0.06;
const DECKSMITH_FEET_OFFSET_Y = 48;
const DECKSMITH_FOREGROUND_DEPTH = 80;
const DECKSMITH_FOREGROUND_HEIGHT = 40;

export default class DeckSmithScene extends BaseInteriorScene {
  constructor() {
    super(
      "DecksmithScene",
      BaseInteriorScene.extractCollisionDataFromMapSource(
        decksmithSource,
        "TestCollisions",
      ),
      voidDecksmithBg,
      {
        exit: { to: "VoidCity2Scene", spawnAt: { x: 1075, y: 410 } },
      },
      getVoidCityNpcDialogue,
    );
  }

  preload() {
    super.preload();
    this.load.image(DECKSMITH_NPC_KEY, decksmithNpcPng);
  }

  create(data) {
    super.create(data);

    this.createAmbientInteriorNpc({
      textureKey: "interiorAmbientNpcC",
      x: 550,
      y: 392,
      facing: "left",
    });

    const collisionLayer = decksmithSource.layers.find(
      (layer) => layer.type === "objectgroup" && layer.name === "TestCollisions",
    );
    const decksmithAnchor = collisionLayer?.objects?.find(
      (object) => object.name === "decksmith",
    );
    const deskAnchor = collisionLayer?.objects?.find(
      (object) => object.name === "desk",
    );

    if (!decksmithAnchor) return;

    const anchorX = decksmithAnchor.x + decksmithAnchor.width / 2;
    const npcY =
      decksmithAnchor.y + decksmithAnchor.height + DECKSMITH_FEET_OFFSET_Y;

    this.add
      .image(anchorX, npcY, DECKSMITH_NPC_KEY)
      .setOrigin(0.5, 1)
      .setScale(DECKSMITH_NPC_SCALE)
      .setDepth(70);

    if (deskAnchor) {
      this.add
        .image(0, 0, `${this.scene.key}_bg`)
        .setOrigin(0)
        .setDepth(DECKSMITH_FOREGROUND_DEPTH)
        .setCrop(
          deskAnchor.x,
          deskAnchor.y,
          deskAnchor.width,
          DECKSMITH_FOREGROUND_HEIGHT,
        );
    }
  }
}
